<template>
    <v-layout row>
        <v-flex xs12>
            <h1 class="caption white--text">
                <u class="link" @click="showPopup(doc_type.disclaimer)">Disclaimer</u> | 
                <u class="link" @click="showPopup(doc_type.cookie)">Cookie Policy</u> |  
                <u class="link" @click="showPopup(doc_type.eula)">EULA Policy</u> | 
                <u class="link" @click="showPopup(doc_type.returnrefund)">Return & Refund Policy</u>
            </h1>
        </v-flex>
        <v-dialog v-model="dialog" width="800">
            <legal-docs-viewer ref="refViewer" :dialog.sync="dialog"></legal-docs-viewer>
        </v-dialog>
    </v-layout>
</template>
<script>
export default {
    data() {
        return {
            dialog: false,
            doc_type: {
                privacy: 'Privacy Policy',
                terms: 'Terms & Conditions',
                disclaimer: 'Disclaimer',
                cookie: 'Cookie Policy',
                eula: 'EULA Policy',
                returnrefund: 'Return & Refund Policy'
            },
            data: [
                {
                    type: 'Disclaimer',
                    header: 'Disclaimer',
                    effectiveDate: 'February 14, 2024',
                    intro: `The following disclaimer outlines the limitations and disclaimers of liability for the use of SweldoNow, a cloud-based payroll system (referred to as "SweldoNow" or the "Service") provided by SweldoNow OPC., a company registered in the Philippines. By using SweldoNow, you acknowledge and agree to the following:`,
                    details: [
                        {
                            title: 'Service Provided "As Is"',
                            description: 'SweldoNow is provided on an "as is" and "as available" basis. SweldoNow OPC. makes no representations or warranties of any kind, express or implied, regarding the Service, its availability, reliability, accuracy, or fitness for a particular purpose.',
                            items: []
                        },
                        {
                            title: 'No Tax, Payroll, or Legal Advice',
                            description: 'SweldoNow is a payroll solutions provider and does not provide tax, legal, accounting, or payroll consulting services. Any information, system defaults, configurations, or computations made available through the Service are for general implementation purposes only and should not be construed as professional advice.',
                            items: []
                        },
                        {
                            title: 'Customer Responsibility for Compliance and Filings',
                            description: 'Customers are solely responsible for ensuring that their payroll configurations, tax treatments, and statutory reports comply with applicable laws, rules, and regulations of the Bureau of Internal Revenue (BIR) and other government agencies. This includes, but is not limited to, the preparation, review, and filing of BIR Forms such as 1601, 2316, and other related reports.',
                            items: []
                        },
                        {
                            title: 'System Defaults and Customer-Defined Configurations',
                            description: 'SweldoNow may provide system defaults based on common Philippine payroll practices. Customers may modify or override these defaults based on their internal policies or requirements. Any deviation from standard or commonly accepted payroll or tax treatments implemented at the customer’s request shall be the sole responsibility of the customer.',
                            items: []
                        },
                        {
                            title: 'Accuracy and Completeness of Information',
                            description: 'While SweldoNow strives to provide accurate and up-to-date system functionality, it does not guarantee the accuracy, completeness, or applicability of any payroll results, tax computations, or reports generated by the Service. Users are responsible for reviewing, validating, and approving all payroll outputs before use or submission to any authority.',
                            items: []
                        },
                        {
                            title: 'Third-Party Integration and External Links',
                            description: 'SweldoNow may provide integrations or links to third-party websites or services. These third-party integrations and links are provided for convenience only. SweldoNow OPC. does not endorse, control, or assume responsibility for the content, availability, security, or practices of these third-party services.',
                            items: []
                        },
                        {
                            title: 'Security and Data Protection',
                            description: 'SweldoNow implements reasonable technical and organizational security measures to protect user data. However, no system is entirely secure, and SweldoNow OPC. does not guarantee absolute security. Users are responsible for safeguarding their access credentials and for ensuring that data entered into the Service is accurate and lawful.',
                            items: []
                        },
                        {
                            title: 'Limitation of Liability',
                            description: 'To the fullest extent permitted by applicable law, SweldoNow OPC. shall not be liable for any direct, indirect, incidental, consequential, or special damages, including but not limited to loss of profits, penalties, tax assessments, data loss, or business interruption, arising out of or in connection with the use of or inability to use the Service.',
                            items: []
                        },
                        {
                            title: 'Indemnification',
                            description: 'Users agree to indemnify, defend, and hold harmless SweldoNow OPC., its directors, officers, employees, and affiliates from any claims, liabilities, penalties, damages, losses, or expenses (including reasonable attorney’s fees) arising from the user’s payroll configurations, tax treatments, statutory filings, or violation of applicable laws or regulations.',
                            items: []
                        },
                        {
                            title: 'Modification of Service',
                            description: 'SweldoNow OPC. reserves the right to modify, enhance, suspend, or discontinue any part of the Service at any time, with or without prior notice. Such modifications may include changes to features, functionality, or availability.',
                            items: []
                        },
                        {
                            title: 'Governing Law and Jurisdiction',
                            description: 'These disclaimers shall be governed by and construed in accordance with the laws of the Republic of the Philippines. Any disputes arising out of or relating to these disclaimers or the use of SweldoNow shall be subject to the exclusive jurisdiction of the courts of the Philippines.',
                            items: []
                        }
                    ],
                    footer: 'Please review these disclaimers carefully before using SweldoNow. By continuing to use the Service, you acknowledge that you understand and accept these terms. If you do not agree with any part of this disclaimer, you should discontinue use of the Service.'
                },
                {
                    type: 'Cookie Policy',
                    header: 'Cookie Policy',
                    effectiveDate: 'February 14, 2024',
                    intro: `This Cookie Policy ("Policy") explains how SweldoNow OPC. ("SweldoNow," "we," "us," or "our") uses cookies and similar technologies on the SweldoNow website and cloud payroll system (referred to as "SweldoNow" or the "Service"). By using SweldoNow, you consent to the use of cookies as described in this Policy.`,
                    details: [
                        {
                            title: 'What are Cookies?',
                            description: 'Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you visit a website. They enable the website to recognize your device, remember your preferences, and provide a personalized user experience.',
                            items: []
                        },
                        {
                            title: 'How We Use Cookies',
                            description: 'SweldoNow uses cookies and similar technologies for various purposes, including but not limited to:',
                            items: [
                                {
                                    item: 'Providing and improving the functionality of the Service'
                                },
                                {
                                    item: 'Analyzing usage patterns and performance of the Service'
                                },
                                {
                                    item: 'Customizing your experience and remembering your preferences'
                                },
                                {
                                    item: 'Delivering targeted advertisements and marketing communications'
                                },
                                {
                                    item: 'Preventing fraudulent activities and enhancing security'
                                }
                            ]
                        },
                        {
                            title: 'Types of Cookies We Use',
                            description: '',
                            items: [
                                {
                                    item: 'Essential Cookies: These cookies are necessary for the operation of SweldoNow and enable you to access and use the Service. They are essential for features such as user authentication, account security, and system management.'
                                },
                                {
                                    item: 'Analytics and Performance Cookies: We use these cookies to collect information about how users interact with SweldoNow, including pages visited, time spent on each page, and any errors encountered. This data helps us analyze and improve the performance and usability of the Service.'
                                },
                                {
                                    item: 'Functionality Cookies: These cookies allow us to remember your preferences and provide personalized features. For example, they may remember your language preference, region, or settings.'
                                },
                                {
                                    item: 'Advertising and Targeting Cookies: SweldoNow may work with third-party advertising partners who use cookies to deliver targeted advertisements based on your interests and online activities. These cookies may track your browsing behavior across different websites.'
                                }
                            ]
                        },
                        {
                            title: 'Third-Party Cookies',
                            description: 'SweldoNow may allow third-party service providers to set and access their cookies on your device. These providers may include analytics and advertising partners. Please note that we do not have control over these third-party cookies and their use is subject to their respective privacy policies.',
                            items: []
                        },
                        {
                            title: 'Managing Cookies',
                            description: 'Most web browsers allow you to control and manage cookies through their settings. You can typically modify your browser settings to accept or reject cookies, or to prompt you before accepting a cookie. However, please note that disabling or blocking certain cookies may affect the functionality and performance of SweldoNow.',
                            items: []
                        },
                        {
                            title: 'Updates to the Cookie Policy',
                            description: 'SweldoNow reserves the right to update or modify this Cookie Policy at any time. Any changes will be effective immediately upon posting the revised Policy on the SweldoNow website. We encourage you to review this Policy periodically for any updates.',
                            items: []
                        },
                        {
                            title: 'Contact Us',
                            description: `If you have any questions or concerns about this Cookie Policy or SweldoNow's use of cookies, please contact us at support@sweldonow.ph`,
                            items: []
                        },
                    ],
                    footer: 'By continuing to use SweldoNow, you consent to the use of cookies as described in this Cookie Policy.'
                },
                {
                    type: 'EULA Policy',
                    header: 'EULA Policy',
                    effectiveDate: 'February 14, 2024',
                    intro: `This End User License Agreement ("Agreement") is a legal agreement between you (referred to as "User" or "You") and SweldoNow ("Company" or "We") governing the use of our cloud payroll service (referred to as the "Service"). By using the Service, you agree to be bound by the terms and conditions of this Agreement. If you do not agree with these terms and conditions, you should not use the Service.`,
                    details: [
                        {
                            title: 'Grant of License',
                            description: '',
                            items: [
                                {
                                    item: 'Subject to the terms and conditions of this Agreement, the Company grants you a non-exclusive, non-transferable, revocable license to access and use the Service for your internal payroll processing and related purposes.'
                                },
                                {
                                    item: 'This license is granted solely for your use and does not extend to any third party. You may not sublicense, distribute, transfer, or assign your rights under this license without the prior written consent of the Company.'
                                }
                            ]
                        },
                        {
                            title: 'Intellectual Property Rights',
                            description: '',
                            items: [
                                {
                                    item: 'The Service, including but not limited to software, trademarks, logos, and other intellectual property, is the sole property of the Company. This Agreement does not grant you any ownership or rights to the Service, except as expressly stated herein.'
                                },
                                {
                                    item: 'You shall not modify, adapt, translate, reverse engineer, decompile, disassemble, or create derivative works based on the Service, except to the extent expressly permitted by applicable law.'
                                }
                            ]
                        },
                        {
                            title: 'User Responsibilities',
                            description: '',
                            items: [
                                {
                                    item: 'You are responsible for maintaining the confidentiality and security of your account credentials and any other login information associated with the Service. You agree to promptly notify the Company of any unauthorized access or use of your account.'
                                },
                                {
                                    item: 'You shall use the Service in compliance with all applicable laws and regulations, including but not limited to data protection, privacy, and labor laws in the Philippines.'
                                },
                                {
                                    item: 'You are responsible for the accuracy and legality of the data entered into the Service and for complying with any legal obligations regarding the processing and protection of personal data.'
                                }
                            ]
                        },
                        {
                            title: 'Data Privacy and Security',
                            description: '',
                            items: [
                                {
                                    item: 'The Company takes data privacy and security seriously. We implement reasonable measures to protect your data from unauthorized access or disclosure. However, you understand and acknowledge that no system can guarantee absolute security.'
                                },
                                {
                                    item: `By using the Service, you consent to the collection, processing, and storage of your data in accordance with the Company's Privacy Policy.`
                                }
                            ]
                        },
                        {
                            title: 'Limitation of Liability',
                            description: '',
                            items: [
                                {
                                    item: 'To the maximum extent permitted by law, the Company shall not be liable for any direct, indirect, incidental, consequential, or special damages arising out of or in connection with the use or inability to use the Service, including but not limited to loss of profits, data, or business opportunities.'
                                }
                            ]
                        },
                        {
                            title: 'Termination',
                            description: '',
                            items: [
                                {
                                    item: 'The Company reserves the right to suspend, terminate, or restrict your access to the Service at any time, with or without cause and without prior notice.'
                                },
                                {
                                    item: 'Upon termination, you must cease all use of the Service and destroy any copies of software or documentation provided by the Company.'
                                }
                            ]
                        },
                        {
                            title: 'Governing Law and Jurisdiction',
                            description: '',
                            items: [
                                {
                                    item: 'This Agreement shall be governed by and construed in accordance with the laws of the Republic of the Philippines. Any dispute arising out of or in connection with this Agreement shall be subject to the exclusive jurisdiction of the courts of the Philippines.'
                                }
                            ]
                        },
                        {
                            title: 'Entire Agreement',
                            description: '',
                            items: [
                                {
                                    item: 'This Agreement constitutes the entire agreement between you and the Company regarding the use of the Service and supersedes any prior or contemporaneous agreements, understandings, or representations, whether oral or written.'
                                }
                            ]
                        },
                    ],
                    footer: '<br>By using the Service, you acknowledge that you have read, understood, and agree to be bound by the terms and conditions of this Agreement.<br><br>If you have any questions or concerns regarding this Agreement, please contact us at support@sweldonow.ph.'
                },
                {
                    type: 'Return & Refund Policy',
                    header: 'Return & Refund Policy',
                    effectiveDate: 'February 14, 2024',
                    intro: `Thank you for choosing SweldoNow.ph, our Cloud Payroll system. We strive to provide you with a reliable and efficient service. This Return and Refund Policy explains the terms and conditions regarding cancellations and refunds for our Cloud Payroll system in the Philippines.`,
                    details: [
                        {
                            title: 'No Refund Policy',
                            description: 'All purchases and payments made for our Cloud Payroll system are non-refundable. We do not offer refunds for any reason, including but not limited to:',
                            items: [
                                {
                                    item: 'Subscription fees'
                                },
                                {
                                    item: 'Customization fees'
                                },
                                {
                                    item: 'Fees for additional services or modules'
                                },
                                {
                                    item: 'Any other fees associated with our Cloud Payroll system'
                                }
                            ]
                        },
                        {
                            title: 'Cancellation',
                            description: '',
                            items: [
                                {
                                    item: 'Customers have the right to cancel their subscription at any time. However, please note that the cancellation will not entitle the customer to a refund or partial refund of any kind.'
                                },
                                {
                                    item: 'To cancel your subscription, please follow the instructions provided in our platform or contact our customer support team at support@sweldonow.ph.'
                                }
                            ]
                        },
                        {
                            title: 'Exceptions',
                            description: 'There are no exceptions to our "No Refund" policy. Regardless of the circumstances, including but not limited to service utilization, service performance, or changes in business requirements, no refunds will be granted.',
                            items: []
                        },
                        {
                            title: 'Contact Information',
                            description: 'If you have any questions or concerns regarding our Return and Refund Policy, please contact our customer support team at support@sweldonow.ph.',
                            items: []
                        },
                    ],
                    footer: 'Please note that this Return and Refund Policy is subject to change without prior notice. We recommend reviewing this policy periodically for any updates.'
                }
            ]       
        }
    },
    components: {
        'legal-docs-viewer': () => import("@/components/Common/LegalDocsViewer"),
    },
    methods: {
        showPopup(type) {
            const selectedData = this.data.filter(x=> x.type == type)[0]
            this.$refs.refViewer.setData(selectedData)
            this.dialog = true
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        }
    },
    created() {
    }
}
</script>
<style scoped>
.link:hover {
    text-decoration: underline;
    color:#1976D2;
    cursor:pointer;
}
</style>